import { DOMAIN_TITLE } from '@/config/env';

export const routes = [
    {
        path: '/',
        name: 'Top',
        component: resolve => require(['@/pages/Top.vue'], resolve),
        meta: { title: `${DOMAIN_TITLE}`, auth:false }
    },
    {
        path: '/login',
        name: 'Login',
        component: resolve => require(['@/pages/Login.vue'], resolve),
        meta: { title: `${DOMAIN_TITLE} | Login`, auth:false }
    },
    {
        path: '/office',
        name: 'office',
        component: resolve => require(['@/pages/office/Index.vue'], resolve),
        meta: { adminAuth: false, auth:true },
        children: [
            {
                path: 'welcome',
                name: 'welcome',
                component: resolve => require(['@/pages/office/Welcome.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Accueil`, adminAuth: false, auth:true }
            },
            {
                path: 'order',
                name: 'newOrder',
                component: resolve => require(['@/pages/office/Order.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Nouvelle commande`, adminAuth: false, auth:true }
            },
            {
                path: 'orderList',
                name: 'orderList',
                component: resolve => require(['@/pages/office/Orders.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Liste commandes`, adminAuth: false, auth:true }
            },
            {
                path: 'faq',
                name: 'faq',
                component: resolve => require(['@/pages/office/Faq.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | FAQ`, adminAuth: false, auth:true }
            },
            {
                path: 'changePasswords',
                name: 'changePasswords',
                component: resolve => require(['@/pages/office/ChangePasswords.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Changer mot de passes`, adminAuth: false, auth:true }
            }
        ]
    },
    {
        path: '/admin',
        name: 'admin',
        component: resolve => require(['@/pages/admin/Index.vue'], resolve),
        meta: { adminAuth: true },
        children: [
            {
                path: 'dashboard',
                name: 'dashboard',
                component: resolve => require(['@/pages/admin/Dashboard.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Dashboard`, adminAuth: true, auth:true }
            },
            {
                path: 'calendar',
                name: 'calendar',
                component: resolve => require(['@/pages/admin/Calendar.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Calendrier`, adminAuth: true, auth:true }
            },
            {
                path: 'orders',
                name: 'orderListAdmin',
                component: resolve => require(['@/pages/admin/Orders.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Commandes`, adminAuth: true, auth:true }
            },
            {
                path: 'users',
                name: 'users',
                component: resolve => require(['@/pages/admin/Users.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Utilisateurs`, adminAuth: true, auth:true }
            },
            {
                path: 'dyn-contents',
                name: 'dynContents',
                component: resolve => require(['@/pages/admin/DynamicContents.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Contenus dynamiques`, adminAuth: true, auth:true }
            },
            {
                path: 'user-history',
                name: 'userHistory',
                component: resolve => require(['@/pages/admin/UserHistory.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Historique des actions utilisateurs`, adminAuth: true, auth:true }
            },
            {
                path: 'statistic',
                name: 'statistic',
                component: resolve => require(['@/pages/admin/Statistic.vue'], resolve),
                meta: { title: `${DOMAIN_TITLE} | Statistique`, adminAuth: true, auth:true }
            }
        ]
    },
    {
        path: '*',
        component: resolve => require(['@/pages/404.vue'], resolve),
        meta: { title: `${DOMAIN_TITLE} | Erreur 404` }
    }
];



// WEBPACK FOOTER //
// ./src/router/routes.js